export const crownpoint = {
    content: {
        line1: {
            header: "25 บาท = 1 คราวน์พอยท์",
            description: "รับ 1 คราวน์พอยท์ทุก 25 บาทในการซื้อผ่านออนไลน์และที่สาขา <span class='not-cut'>คราวน์พอยท์</span> สามารถนำมาแลกสิทธิพิเศษและของรางวัลจากทางเบอร์เกอร์คิงและบริษัทที่ร่วมรายการ"
        },
        line2: {
            header: "พอยท์หมดอายุ = 1 ปี",
            description: "พอยท์ของท่านจะมีอายุ 1 ปีในการแลกสิทธิพิเศษ ในกรณีที่คุณได้รับพอยท์ในเดือนมกราคม พอยท์ของคุณจะหมดอายุตอนสิ้นเดือนมกราคมปีถัดไป คุณสามารถตรวจสอบยอดสะสมคะแนนได้โดยไปที่หน้าเมนู มายพอยท์"
        },
        line3: {
            header: "พอยท์ไม่สามารถโอนให้ผู้อื่นได้",
            description: "พอยท์ของคุณเป็นสิทธิเฉพาะของคุณเท่านั้นและไม่สามารถแลกเปลี่ยนหรือขายให้ผู้อื่นได้ และไม่สามารถแลกเปลี่ยนเป็นเงินสดได้ </br> พอยท์และสิทธิพิเศษจะไม่ร่วมกับสาขาที่ท่าอากาศยาน จังซีลอน 1,จังซีลอน 2, บางลา, ป่าตอง, บางลา-ป่าตอง, สมุย, สมุยลีฟวิ่งพลาซ่า, โอทอปป่าตอง, กระบี่  บริการ Drive Thru และ บริการโทรสั่งผ่าน 1112"
        },
        line4: {
            header: "บริการสามารถใช้ร่วมกับรายการอื่น",
            description: "คุณสามารถใช้บริการนี้ร่วมกับโปรโมชั่นต่างๆและสามารถสะสมคราวน์พอยท์ได้ในจำนวนเงินที่ใช้จ่ายหลังจากหักส่วนลดที่ร่วมกับโปรโมชั่นแล้ว"
        },
        line5: {
            header: "ระดับขั้นวอปเปอร์",
            description: "สำหรับลูกค้าทุกท่านของ Burger King ขณะนี้คุณสามารถรับ ระดับขั้นวอปเปอร์ ที่แตกต่างกันถึง 4ระดับ ซึ่งจะได้รับสิทธิประโยชน์ที่แตกต่างกันและเพิ่มขึ้นเรื่อยๆในแต่ละ ระดับ ยิ่งสะสมคะแนน Crown Points มาก ก็จะช่วยให้คุณได้รับ ระดับขั้น ที่สูงขึ้นไป สถานะของ ระดับขั้น จะใช้ได้จนถึงแต่ละไตรมาส(31 มีนาคม, 30 มิถุนายน, 30 กันยายน, และ 31 ธันวาคม)"
        },
    },
    POINT: "คราวพอยท์",
    DOWNLOAD_APPLCICATION: "DOWNLOAD APPLICATION",
    Burger_King_Applications: "Burger King Thailand Applications",
};
